import { colors } from "../../../../styles/colors"
import { fonts } from "../../../../styles/fonts"


const daysWrapper = {
    display: "flex",
}

const dayBlock: any = (props: any) => ({
    padding: "11px 35px",
    border: props.isSelected ? 0 : "1px solid #b6ceda",
    marginRight: 7,
    borderRadius: "7px 7px 0 0",
    background: props.isSelected ? colors.white : "#e0e8ec",
    borderBottom: 0,
    boxShadow: props.isSelected ? "3px -3px 4px 0px rgba(0,0,0,0.1)" : "unset",
    textAlign: "center",
    minWidth: "153px",
    cursor: "pointer"
})


const dayName = (props: any) => ({
    color: props.isSelected ? (props.showError ? colors.red : colors.slateBlue) : props.showError ? colors.red : colors.black,
    fontFamily: fonts.boldFont,
    fontSize: 16
})


const dayFocusType: any = (props: any) => ({
    fontFamily: props.isSelected ? fonts.boldFont : fonts.regularFont,
    fontSize: 14,
    color: props.isSelected ? colors.fuschiaPink : colors.black,
    cursor: "pointer",
    marginTop: 18,
    ":hover": {
        textDecoration: props.isSelected && !props.isViewMode && "underline"
    }
})

const addDayFocus: any = (props: any) => ({
    fontFamily: fonts.boldFont,
    fontSize: 14,
    color: props.isSelected ? colors.fuschiaPink : colors.black,
    cursor: "pointer",
    marginTop: 5,

    "::before": {
        content: '"+"',
        position: "relative",
        fontSize: 25,
        bottom: "-4px",
        right: "6px",
    },

    ":hover": {
        textDecoration: props.isSelected && "underline"
    },

    ":hover::before": {
        display: "inline-block" //remove underline from + on hover
    }
})

export {
    dayFocusType,
    dayBlock,
    dayName,
    daysWrapper,
    addDayFocus
}